export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-vietnamese-600-normal.woff2?0a8b303dde286bfa73a5dbe00e27b21e";